import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetch } from '../../../redux/actions';

import DesktopLayerPopup from '../../common/DesktopLayerPopup';
import Preview from './Preview';
import Download from './Download';
import ApplyModal from './ApplyModal';
import { service, values, api } from '../config';

const mapDispatchToProps = (dispatch) => ({
  simpleUpdate: (url, params) => dispatch(fetch.simpleUpdate(url, params)),
});

class ContentItem extends Component {
  onClickPreview(event) {
    event.preventDefault();

    const { item } = this.props;

    const fileDetails = item?.sdata?.fileDetails ?? [];
    const previewImageUrl = fileDetails?.find((_) => true)?.file ?? '';

    DesktopLayerPopup.modal(<Preview imageUrl={previewImageUrl} />);
  }

  async onClickDownload(event) {
    event.preventDefault();

    const { parent, student, item } = this.props;

    if (!parent?.id) {
      return DesktopLayerPopup.login();
    }

    if (!service.isAbleDownloadStatus(student) && !service.getIsFree(item)) {
      return DesktopLayerPopup.modal(<ApplyModal history={history} />);
    }

    const contentFiles = item?.data?.contentFiles ?? [];
    if (contentFiles.length === 1) {
      const isDownloadable = await service.checkAllDownloadable(contentFiles);
      if (isDownloadable) {
        for (const file of contentFiles) {
          await service.downloadWithTimeout({
            url: file.filePath,
            fileName: file.title,
          });
        }
        await this.createDownloadLog(item, contentFiles);
      } else {
        DesktopLayerPopup.notice({
          message:
            '다운로드가 불가능합니다.<br />' + '운영자에게 문의해주세요.',
        });
      }
    } else {
      DesktopLayerPopup.modal(
        <Download
          item={item}
          createDownloadLog={this.createDownloadLog.bind(this)}
        />
      );
    }
  }

  createDownloadLog(content, selectedList) {
    const { student, parent } = this.props;

    const attributeTags = content?.data?.tags?.PostAttributeTag ?? [];
    const categoryTags = content?.data?.tags?.PostCategoryTag ?? [];

    const isRecommended = !!attributeTags.find((item) => item === '추천');

    const apiParams = {
      student_id: student.id,
      student_auth_human_name: student?.auth_human_name ?? '',
      student_status: student?.status ?? '',
      parent_id: parent.id,
      parent_auth_human_name: parent.auth_human_name,
      post_category_tag: (categoryTags?.leaf ?? []).find((_) => true),
      post_attribute_tag: attributeTags,
      post_subjects: service.makePostSubjects(content, selectedList),
      is_recommended: isRecommended,
    };

    const apiObj = api.createDownloadLog(parent.id, apiParams);

    return this.props.simpleUpdate(apiObj.url, apiObj.params);
  }

  renderThumbnail() {
    const { item } = this.props;

    const thumbnailUrl = item?.data?.thumbnailUrl ?? '';
    const attributeTags = item?.data?.tags?.PostAttributeTag ?? [];

    const recommend = !!attributeTags.find((item) => item === '추천');

    return (
      <div className="thumbnail-container">
        <div className="thumbnail">
          <img className="thumbnail-img" src={thumbnailUrl} alt="썸네일" />
        </div>
        {recommend && (
          <img className="recommend" src={values.images.recommend} alt="추천" />
        )}
      </div>
    );
  }

  renderTitle() {
    const { item } = this.props;

    const title = item?.title ?? '';
    const isFree = service.getIsFree(item);

    return (
      <div className="title-container">
        <div className="title">{title}</div>
        <img src={isFree ? values.images.free : values.images.paid} alt="" />
      </div>
    );
  }

  renderDescription() {
    const { item } = this.props;

    const description = item?.html ?? '';

    return <div className="item-description">{description}</div>;
  }

  renderPreviewButton() {
    return (
      <div
        className="preview-button"
        onClick={this.onClickPreview.bind(this)}
        id="reference-room-preview"
      >
        <img src={values.images.previewButton} alt="미리보기" />
      </div>
    );
  }

  renderDownloadButton() {
    return (
      <div
        className="download-button"
        onClick={this.onClickDownload.bind(this)}
        id="reference-room-download"
      >
        <img src={values.images.downloadButton} alt="다운로드" />
      </div>
    );
  }

  renderButtons() {
    return (
      <div className="button-container">
        {this.renderPreviewButton()}
        {this.renderDownloadButton()}
      </div>
    );
  }

  render() {
    return (
      <div className="content-item">
        {this.renderThumbnail()}
        <div className="content-wrapper">
          {this.renderTitle()}
          {this.renderDescription()}
          {this.renderButtons()}
        </div>
      </div>
    );
  }
}

export default connect(null, mapDispatchToProps)(ContentItem);
